import React from "react";
import { Button } from "react-bootstrap";
import Card from 'react-bootstrap/Card';

function AddNewBenchmark({setCreateBenchmarkSection}) {
  return (
    <div className="custom_card_wrapper_sidecard">
      <div className="col-md-12 mb-3">
        <div className="guide_selection_wrapper">
          <div className="border_grad_guide"></div>
          <Card className="custom_card_guide">
            <Card.Header className="custom_card_guide_header">
              <span className="initial_sidecard">A</span> Guided Selection
            </Card.Header>
            <Card.Body className="custom_card_guide_body">
              <p className="custom_para_card">
                Step-by-step dropdown menus for systematic benchmark creation.
                Perfect for structured thinkers and first-time users.
              </p>
              <p className="custom_setup_list">
                <span className="custom_setup_bold">Setup:</span> 10 - 15
                minutes
              </p>
              <p className="custom_setup_list">
                <span className="custom_setup_bold">Best for:</span> Systematic
                analysts • New users
              </p>
              <p className="custom_setup_list">
                <span className="custom_setup_bold">Output:</span> Comprehensive
                structured benchmark
              </p>
              <Button variant="primary" className="card_custom_btn" onClick={() => setCreateBenchmarkSection("guidedSelection")}>
                Start Guided Setup
              </Button>
            </Card.Body>
          </Card>
        </div>
      </div>
      <div className="col-md-12 mb-3">
        <div className="natural_language_wrapper">
          <div className="border_grad_nl"></div>

          <Card className="custom_card_guide">
            <Card.Header className="custom_card_guide_header">
              <span className="initial_sidecard">B</span> Natural Language
            </Card.Header>
            <Card.Body className="custom_card_guide_body">
              <p className="custom_para_card">
                Describe your needs in plain English. AI interprets and creates
                your benchmark structure.
              </p>
              <p className="custom_setup_list">
                <span className="custom_setup_bold">Setup:</span> 3 - 5 minutes
              </p>
              <p className="custom_setup_list">
                <span className="custom_setup_bold">Best for:</span>{" "}
                Conversational users • Complex requirements
              </p>
              <p className="custom_setup_list">
                <span className="custom_setup_bold">Output:</span> AI-optimized
                benchmark framework
              </p>
              <Button variant="primary" className="card_custom_btn" onClick={() => setCreateBenchmarkSection("naturalLanguage")}>
                Describe Requirements
              </Button>
            </Card.Body>
          </Card>
        </div>
      </div>
      <div className="col-md-12 mb-3">
        <div className="template_upload_wrapper">
          <div className="border_grad_upload"></div>

          <Card className="custom_card_guide">
            <Card.Header className="custom_card_guide_header">
              <span className="initial_sidecard">C</span> Template Upload
            </Card.Header>
            <Card.Body className="custom_card_guide_body">
              <p className="custom_para_card">
                Upload your existing framework or template. We'll adapt it to
                our platform.
              </p>
              <p className="custom_setup_list">
                <span className="custom_setup_bold">Setup:</span> 2 - 8 minutes
              </p>
              <p className="custom_setup_list">
                <span className="custom_setup_bold">Best for:</span> Existing
                framework users • Enterprise teams
              </p>
              <p className="custom_setup_list">
                <span className="custom_setup_bold">Output:</span> Adapted
                existing framework
              </p>
              <Button variant="primary" className="card_custom_btn" onClick={() => setCreateBenchmarkSection("templateUpload")}>
                Upload Template
              </Button>
            </Card.Body>
          </Card>
        </div>
      </div>
    </div>
  );
}

export default AddNewBenchmark;